// convert milligrams per deciliter to millimoles per liter
export function mgdlToMmoll(n: number): number {
  return n / 18
}
